import { Input } from "antd";

/* eslint-disable-next-line */
export interface PriceInputProps {
  price: number;
  onChange: (price: number) => void;
}

export function PriceInput({ price, onChange }: PriceInputProps) {
  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const newPrice = e.target.value.trim().replace(',', '.').replace(/[^0-9.]/g, '');
      const priceInCents = Math.round(parseFloat(newPrice) * 100);
      onChange(isNaN(priceInCents) ? price : priceInCents);
    } catch (e) {
      onChange(price || 0);
    }
  }
  return (
    <Input value={(price / 100).toFixed(2)} onChange={handlePriceChange} />
  );
}

export default PriceInput;
